import React from "react";

import * as Styled from "./styles";

interface UserBadgeProps {
  name: string;
  company?: string;
  className?: string;
}

/**
 * Compact user identity chip used in the Navbar: a colored circle with the
 * user's initials, name and (optionally) the company / tenant name.
 */
const UserBadge: React.FC<UserBadgeProps> = ({ name, company, className }) => {
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();

  return (
    <Styled.Container className={className}>
      <Styled.Initials aria-hidden>{initials}</Styled.Initials>
      <Styled.Info>
        <Styled.Name>{name}</Styled.Name>
        {company && <Styled.Company>{company}</Styled.Company>}
      </Styled.Info>
    </Styled.Container>
  );
};

UserBadge.defaultProps = {
  company: undefined,
  className: undefined
};

export default UserBadge;
